import script from "./Modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Modal.vue?vue&type=script&setup=true&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=b6275676&lang=css"

const __exports__ = script;

export default __exports__